// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// ✅ پیکربندی Firebase - جایگزین با مقادیر پروژه خودت کن
const firebaseConfig = {
  apiKey: "AIzaSyDKnSMEr1_K_jUkdjJEdoRsWKqM51qKcqE",
  authDomain: "reza-14.firebaseapp.com",
  projectId: "reza-14",
  storageBucket: "reza-14.firebasestorage.app",
  messagingSenderId: "167620465658",
  appId: "1:167620465658:web:33615c3f10c400f0a34a43",
  measurementId: "G-E34EBWRV5M"
};

// ✅ راه‌اندازی Firebase
const app = initializeApp(firebaseConfig);

// ✅ ماژول‌های مورد نیاز
const auth = getAuth(app);
const db = getFirestore(app);
const provider = new GoogleAuthProvider();

// ✅ تابع ورود با گوگل
const signInWithGoogle = () => signInWithPopup(auth, provider);

// ✅ صادر کردن برای استفاده در پروژه
export { auth, db, signInWithGoogle, provider };





